import axios from "../utils/axios";

// 🏢 Get Product Category
// export const getProductCategory = async (req) => {
//   const response = await axios.get("/api/ProductCategory/GetAll");
//   console.log(response);
//   return response.data;
// };

// 🏢 Get Product List
// export const getProductList = async (req) => {
//   const response = await axios.get("/api/Product/GetListProductIndex", {
//     params: req,
//   });
//   console.log(response);
//   return response.data;
// };

// 🏢 Get Product List
export const updateUserProfile = async (req) => {
  const response = await axios.post("/api/User/UpdateUserProfile", req);
  //console.log(response);
  return response.data;
};

// 🏢 Get Product List
export const updatePassword = async (req) => {
  const response = await axios.post("/api/User/ChangePasswordAsync", req);
  //console.log(response);
  return response.data;
};
